import axios from "axios";
import Config from "src/config";

const v2_actionEditarServico = (id, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/servicos/${id}/editar`,
        data
    });
};

export default v2_actionEditarServico;
